import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset from "models/NotificationAsset"

export interface IGetNotificationReferenceNumbersUpdatedDto extends IGetNotification {
    notificationType: NotificationType.referenceNumbersUpdated
    changedAssetId: Guid
    assets: Guid[]
}

export default class NotificationReferenceNumbersUpdated extends Notification {
    changedAssetId: Guid
    changedAsset: NotificationAsset
    assetIds: Guid[]
    assets: NotificationAsset[]

    constructor(dto: IGetNotificationReferenceNumbersUpdatedDto) {
        super(dto)

        this.changedAssetId = dto.changedAssetId
        this.changedAsset = new NotificationAsset({
            assetId: dto.changedAssetId
        })

        this.assetIds = dto.assets
        this.assets = dto.assets.map(assetId => new NotificationAsset({
            assetId: assetId
        }))
    }
}
